import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _TaxHoldvtwo } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { TaxHoldType } from "./TaxHoldType";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";


export const TaxHoldvtwo = () => {

    const hold = useDataBean(_TaxHoldvtwo);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        hold.instance.getTaxHoldCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        hold.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        hold.deleteItemVoid(hold.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Agregar Nivel Jerárquico de Empleo`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        hold.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTaxHold', visible: true },
        { title: 'Orden de Aplicación', property: 'TaxHoldOrder', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo', property: 'Type', visible: true },
        { title: 'Clase Java', property: 'Formula', visible: true },
        { title: 'Celda Certificado', property: 'Cell', visible: true },
        { title: 'Valor Máximo (1)', property: 'MaxValue1', visible: true, mask: MASK_NUMBER },
        { title: 'Unidades (1)', property: 'MaxValueTypeName', visible: true },
        { title: 'Valor Máximo (2)', property: 'MaxValue2', visible: true, mask: MASK_NUMBER },
        { title: 'Unidades (2)', property: 'MaxValueTypeName2', visible: true },
        { title: 'Responsable de Renta', property: 'RentTaxApply', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Conceptos de Cálculo de Retefuente de Empleados">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={hold.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-6">
                                <label>Orden de Aplicación</label>
                                <input type="text" name="TaxHoldOrder" className="form-control" value={hold.bean.TaxHoldOrder} onChange={(e) => { hold.setBean({ ...hold.bean, "TaxHoldOrder": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Mnemonic</label>
                                <input type="text" name="Mnemonic" className="form-control" value={hold.bean.Mnemonic} onChange={(e) => { hold.setBean({ ...hold.bean, "Mnemonic": e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Tipo</label>
                                <input type="text" name="Type" className="form-control" value={hold.bean.Type} onChange={(e) => { hold.setBean({ ...hold.bean, "Type": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Clase Java</label>
                                <input type="text" name="Formula" className="form-control" value={hold.bean.Formula} onChange={(e) => { hold.setBean({ ...hold.bean, "Formula": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Celda Certificado</label>
                                <input type="text" name="Cell" className="form-control" value={hold.bean.Cell} onChange={(e) => { hold.setBean({ ...hold.bean, "Cell": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor Máximo (1)</label>
                                <input type="text" name="MaxValue1" className="form-control" value={hold.bean.MaxValue1} onChange={(e) => { hold.setBean({ ...hold.bean, "MaxValue1": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Unidades (1)</label>
                                <TaxHoldType idSelector={hold.bean.MaxValueType} onChange={(e) => { hold.setBean({ ...hold.bean, "MaxValueType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor Máximo (2)</label>
                                <input type="text" name="MaxValue2" className="form-control" value={hold.bean.MaxValue2} onChange={(e) => { hold.setBean({ ...hold.bean, "MaxValue2": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Unidades (2)</label>
                                <TaxHoldType idSelector={hold.bean.MaxValueType2} onChange={(e) => { hold.setBean({ ...hold.bean, "MaxValueType2": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="" estado={hold.bean.RentTaxApply} eventChange={(e) => { hold.setBean({ ...hold.bean, "RentTaxApply": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea className="form-control" name='Description' value={hold.bean.Description} onChange={(e) => { hold.setBean({ ...hold.bean, "Description": e.target.value }) }} />
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {hold.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}